import { useState } from "react";
import { motion } from "framer-motion";
import { X, ZoomIn } from "lucide-react";

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/9kvdnnm3_new1.jpg",
      alt: "Sandstone patio with gazebo, resin bound gravel and planters",
      category: "Patio & Gazebo"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/53o6flpy_new2.jpg",
      alt: "Full garden with water feature, gazebo, resin bound and sandstone patio",
      category: "Garden Transformation"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/a9yz43dw_new3.jpg",
      alt: "Sleeper pathway with gravel edging and sandstone patio",
      category: "Pathways"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/iwd8fntp_new4.jpg",
      alt: "Sandstone patio with raised timber planter and sunset",
      category: "Patios & Planters"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/07xvle29_new5.jpg",
      alt: "Roadside clearance and hedge removal with chipper at North Seaton",
      category: "Land Clearance"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/8a4l7c2t_22.jpeg",
      alt: "Block paving driveway with sandstone path and granite edging",
      category: "Driveways"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/j3mvuuov_26.jpg",
      alt: "Climber dismantling birch tree with Pioneer van on site",
      category: "Tree Surgery"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/1mu4axht_WhatsApp%20Image%202026-04-23%20at%2018.24.21.jpeg",
      alt: "Climber working at height on tall pine trees",
      category: "Tree Climbing"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/59b2eavz_WhatsApp%20Image%202026-04-23%20at%2018.27.39.jpeg",
      alt: "Climber in canopy of large tree with rigging lines",
      category: "Crown Reduction"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/h21luqpw_WhatsApp%20Image%202026-04-23%20at%2018.28.56.jpeg",
      alt: "Grey sandstone patio with circular feature and new fencing",
      category: "Sandstone Patio"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/2621krvl_22.jpg",
      alt: "Pioneer van on site with climber felling tree",
      category: "Tree Surgery"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/rmvg5e26_23.jpg",
      alt: "JCB telehandler assisting with large tree removal",
      category: "Tree Removal"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/wdcwl50f_25.jpg",
      alt: "New close board timber fencing with Pioneer branding",
      category: "Fencing"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/82vhq4as_21.jpg",
      alt: "New fence posts with concrete gravel boards being installed",
      category: "Fencing"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/o0xb1x01_p.jpeg",
      alt: "Natural stone patio with turf lawn, shed and timber fencing",
      category: "Patio & Turf"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/4ozxsq2m_w1.jpeg",
      alt: "Arborist in harness using chainsaw on large branch",
      category: "Tree Surgery"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/u95grnrc_WhatsApp%20Image%202026-04-21%20at%2019.48.28.jpeg",
      alt: "Climber at top of conifer during tree felling",
      category: "Tree Felling"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/lbygo8is_17.jpg",
      alt: "Dark slate patio with chiminea, raised planters and flowers",
      category: "Patio & Planters"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/84cz3dnm_18.jpg",
      alt: "Custom treehouse build in large oak tree",
      category: "Treehouse Build"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/mj85w4xf_19.jpg",
      alt: "Stone cottage patio with resin bound gravel and natural stone",
      category: "Resin & Stone Patio"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/jngaincz_20.jpg",
      alt: "Artificial grass installation with curved patio edging",
      category: "Artificial Grass"
    },
  ];

  return (
    <section id="gallery" className="py-16 md:py-24 lg:py-32 bg-[#F9F9F7]" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-12"
        >
          <span className="text-sm font-medium tracking-wide uppercase text-[#8B5A2B] mb-4 block">
            Our Portfolio
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A4D2E] mb-6">
            Recent Work
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Take a look at some of our recent projects across Northumberland — from driveways and patios to garden design and tree work.
          </p>
        </motion.div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="gallery-item cursor-pointer aspect-square sm:aspect-[4/3]"
              onClick={() => setSelectedImage(image)}
              data-testid={`gallery-item-${index}`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
              <div className="gallery-overlay">
                <div className="text-center">
                  <ZoomIn className="w-8 h-8 text-white mb-2 mx-auto" />
                  <span className="text-white font-semibold">{image.category}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
          data-testid="gallery-lightbox"
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
            onClick={() => setSelectedImage(null)}
            data-testid="lightbox-close-btn"
          >
            <X className="w-8 h-8" />
          </button>
          <motion.img
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            src={selectedImage.src}
            alt={selectedImage.alt}
            className="max-w-full max-h-[85vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white text-center">
            <span className="font-heading font-semibold">{selectedImage.category}</span>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
